document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    var headerButton = document.getElementById("headerButton");
    if (headerButton) {
      headerButton.addEventListener("click", (function () {
        var mainNav = document.getElementById("mainNav");
        mainNav.classList.contains("active")
          ? mainNav.classList.remove("active")
          : mainNav.classList.add("active")
      }));
    }
  }, 0)
});
